import { makeStyles } from 'tss-react/mui';

const useStylesChevronSlider: MaterialUIStylesCallback = makeStyles()((theme: MainTheme): MaterialUIStyles => ({
  chevronSliderContainer: {
    marginTop: 10,
    overflow: 'hidden',
  },
  chevron: {
    display: 'inline-flex',
    width: 170,
    height: 35,
    marginTop: 25,
    marginBottom: 20,
  },
  chevronSelected: {
    color: theme.palette.common.white,
  },
  chevronButton: {
    opacity: 1,
    fontSize: 14,
    width: '100%',
    height: 65,
    overflow: 'hidden',
  },
  chevronButtonSelected: {
    opacity: '0.6 !important',
  },
  chevronElement: {
    position: 'absolute',
    marginTop: -15,
    '& svg': {
      width: '100%',
    },
  },
  chevronTitle: {
    position: 'relative',
    marginTop: -2,
    textAlign: 'center',
  },
  chevronSubTitle: {
    marginTop: 2,
    fontWeight: 'bold',
  },
}));

export default useStylesChevronSlider;
